module.exports = __webpack_public_path__ + "assets/img/54aa-sd.svg";